
    <template>
      <section class="relax-doc">
        <h1>Checkbox 多选框</h1>
<blockquote>
<p>有可选项且需要选择多项</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>使用 <code>v-model</code> 双向绑定</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-checkbox v-model=&quot;checked&quot; label=&quot;Checkbox&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const checked = ref(true)

      return {
        checked
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-yong"><a class="header-anchor" href="#jin-yong"></a> 禁用</h2>
<blockquote>
<p>添加 <code>disabled</code> 属性 禁用 <code>checkbox</code></p>
</blockquote>
<demo-block>
        <p>当状态改变时，会触发 <code>change</code> 事件</p>

        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-checkbox label=&quot;one&quot; @change=&quot;change&quot; /&gt;
  &lt;x-checkbox label=&quot;two&quot; disabled /&gt;
  &lt;x-checkbox label=&quot;three&quot; disabled checked /&gt;
  &lt;x-checkbox label=&quot;four&quot; disabled checked&gt; four &lt;/x-checkbox&gt;
&lt;/template&gt;
&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties

      const change = (value) =&gt; {
        $message[value ? 'success' : 'error'](value)
      }

      return {
        change
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="checkbox-zu"><a class="header-anchor" href="#checkbox-zu"></a> checkbox 组</h2>
<blockquote>
<p>使用 <code>CheckboxGroup</code> 配合数组来生成组合。在组合使用时，<code>Checkbox</code> 使用 <code>label</code> 来自动判断选中状态。每个 <code>Checkbox</code> 的内容可以自定义，如不填写则默认使用 <code>label</code> 的值</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-checkbox-group v-model=&quot;options&quot;&gt;
    &lt;x-checkbox label=&quot;one&quot; disabled /&gt;
    &lt;x-checkbox label=&quot;two&quot; /&gt;
    &lt;x-checkbox label=&quot;three&quot;  /&gt;
    &lt;x-checkbox label=&quot;four&quot;  /&gt;
    &lt;x-checkbox label=&quot;five&quot; disabled /&gt;
  &lt;/x-checkbox-group&gt;
  
  &lt;div style=&quot;margin-top: 10px&quot;&gt;
  选中的值：{{options}}
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  import {reactive} from 'vue'
  export default {
    setup(){
      const options = reactive(['one', 'two'])
      
      return {
        options,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="kong-zhi-checkbox"><a class="header-anchor" href="#kong-zhi-checkbox"></a> 控制 checkbox</h2>
<blockquote>
<p>其他组件控制进行数据联动</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-checkbox label=&quot;checkbox&quot; :disabled=&quot;disabled&quot; v-model=&quot;checked&quot; /&gt;
  
  &lt;div style=&quot;margin-top: 10px&quot;&gt;
    &lt;x-button type=&quot;success&quot; size='sm' @click=&quot;checked = !checked&quot;&gt;{{checked ? 'Checked' : 'Unchecked'}}&lt;/x-button&gt;
    &lt;x-button type=&quot;danger&quot; size='sm' @click=&quot;disabled = !disabled&quot;&gt;{{disabled ? 'Disabled' : 'Enabled'}}&lt;/x-button&gt;
  &lt;/div&gt;

&lt;/template&gt;

&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const disabled = ref(true)
      const checked = ref(true)

      return {
        checked,
        disabled
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="bu-ju"><a class="header-anchor" href="#bu-ju"></a> 布局</h2>
<blockquote>
<p><code>Checkbox</code> 与 <code>Grid</code> 组件一起使用，可以实现灵活的布局。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-row&gt;
    &lt;x-col v-for=&quot;item in options&quot; style=&quot;margin-bottom: 10px&quot;&gt;
      &lt;x-checkbox v-model=&quot;item.checked&quot; v-bind=&quot;item&quot; &gt;options {{item.label}}&lt;/x-checkbox&gt;
    &lt;/x-col&gt;
  &lt;/x-row&gt;
&lt;/template&gt;
  
&lt;script&gt;
  import {reactive} from 'vue'
  export default {
    setup(){
      const options = reactive([{
        label: 'one',
        checked: true,
        disabled: true,
      },
      {
        label: 'two',
        checked: true,
        disabled: false,
      },
      {
        label: 'three',
        checked: false,
        disabled: false,
      },
      {
        label: 'four',
        checked: false,
        disabled: true,
      },
      {
        label: 'five',
        checked: false,
        disabled: false,
      }])
      
      return {
        options,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_checkbox = _resolveComponent("x-checkbox")

  return (_openBlock(), _createBlock(_component_x_checkbox, {
    modelValue: _ctx.checked,
    "onUpdate:modelValue": $event => ((_ctx.checked) = $event),
    label: "Checkbox"
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const checked = ref(true)

      return {
        checked
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, createTextVNode: _createTextVNode, withCtx: _withCtx, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_checkbox = _resolveComponent("x-checkbox")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_checkbox, {
      label: "one",
      onChange: _ctx.change
    }, null, 8, ["onChange"]),
    _createVNode(_component_x_checkbox, {
      label: "two",
      disabled: ""
    }),
    _createVNode(_component_x_checkbox, {
      label: "three",
      disabled: "",
      checked: ""
    }),
    _createVNode(_component_x_checkbox, {
      label: "four",
      disabled: "",
      checked: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" four ")
      ]),
      _: 1
    })
  ], 64))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties

      const change = (value) => {
        $message[value ? 'success' : 'error'](value)
      }

      return {
        change
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, toDisplayString: _toDisplayString, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_checkbox = _resolveComponent("x-checkbox")
  const _component_x_checkbox_group = _resolveComponent("x-checkbox-group")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_checkbox_group, {
      modelValue: _ctx.options,
      "onUpdate:modelValue": $event => ((_ctx.options) = $event)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_checkbox, {
          label: "one",
          disabled: ""
        }),
        _createVNode(_component_x_checkbox, { label: "two" }),
        _createVNode(_component_x_checkbox, { label: "three" }),
        _createVNode(_component_x_checkbox, { label: "four" }),
        _createVNode(_component_x_checkbox, {
          label: "five",
          disabled: ""
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", { style: {"margin-top":"10px"} }, " 选中的值：" + _toDisplayString(_ctx.options), 1)
  ], 64))
}
  
    
        const {reactive} = Vue
        
  const democomponentExport = {
    setup(){
      const options = reactive(['one', 'two'])
      
      return {
        options,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, toDisplayString: _toDisplayString, createTextVNode: _createTextVNode, withCtx: _withCtx, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_checkbox = _resolveComponent("x-checkbox")
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_checkbox, {
      label: "checkbox",
      disabled: _ctx.disabled,
      modelValue: _ctx.checked,
      "onUpdate:modelValue": $event => ((_ctx.checked) = $event)
    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", { style: {"margin-top":"10px"} }, [
      _createVNode(_component_x_button, {
        type: "success",
        size: "sm",
        onClick: $event => (_ctx.checked = !_ctx.checked)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.checked ? 'Checked' : 'Unchecked'), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_x_button, {
        type: "danger",
        size: "sm",
        onClick: $event => (_ctx.disabled = !_ctx.disabled)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.disabled ? 'Disabled' : 'Enabled'), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const disabled = ref(true)
      const checked = ref(true)

      return {
        checked,
        disabled
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString, createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, mergeProps: _mergeProps, withCtx: _withCtx, createVNode: _createVNode, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_checkbox = _resolveComponent("x-checkbox")
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createBlock(_component_x_row, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_component_x_col, { style: {"margin-bottom":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_x_checkbox, _mergeProps({
              modelValue: item.checked,
              "onUpdate:modelValue": $event => ((item.checked) = $event)
            }, item), {
              default: _withCtx(() => [
                _createTextVNode("options " + _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1040, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024))
      }), 256))
    ]),
    _: 1
  }))
}
  
    
        const {reactive} = Vue
        
  const democomponentExport = {
    setup(){
      const options = reactive([{
        label: 'one',
        checked: true,
        disabled: true,
      },
      {
        label: 'two',
        checked: true,
        disabled: false,
      },
      {
        label: 'three',
        checked: false,
        disabled: false,
      },
      {
        label: 'four',
        checked: false,
        disabled: true,
      },
      {
        label: 'five',
        checked: false,
        disabled: false,
      }])
      
      return {
        options,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  